export default {
  heading: 'Din, sans-serif',
  body: 'Playfair Display, serif',
  monospace: 'Menlo, monospace',
  display: 'Caveat, cursive',
  googleFonts: [
    'Montserrat:100,200,300,400,500,600,700,800,900',
    'Playfair Display:400,500,600,700,800,900',
    'Caveat:400,500,600,700'
  ],
  customFamilies: ['Din'],
  customUrls: ['https://www.gonation.biz/fonts/din/din.css']
}
